export default __webpack_public_path__ + "static/media/Group1551.d6928874.png";